// R4.A — Health Score distribution for the current period. Data from
// GET /v1/bo/health-score/distribution (see backoffice.routes.js ->
// models.healthScore.getDistribution). Read-only: scores are computed by
// bot_health.js / POST /v1/bo/health-score/recompute, not editable here.
const ACTION_BY_CLASSIFICATION = {
  HIJAU: "Referral / upgrade tier (bukan retensi)",
  KUNING: "Nudge email otomatis per-sebab",
  MERAH: "Sapa langsung (WA) + review mentor",
};

let churnHealthDistributionSection = {
  name: "Distribusi Health Score",
  slug: "churnHealthDistribution",
  visible: true,
  singularName: "churnHealthDistribution",
  crud: true,
  endpoint: "/v1/bo/health-score/distribution",
  updateLabel: "churnHealthDistribution",
  meta: {
    delete_flag: false,
  },
  access: ["superadmin"],
  delete: false,
  noNeedSearch: true,
  noNeedRefresh: false,
  add: false,
  update: false,
  edit: false,
  exportToCsv: false,
  fields: [
    {
      label: "Klasifikasi",
      name: "txt",
      type: "text",
      visible: true,
      resource_label: (row) => {
        const icon = { HIJAU: "🟢", KUNING: "🟡", MERAH: "🔴" }[row.classification] || "";
        return `${icon} ${row.classification || "-"}`;
      },
    },
    {
      label: "Jumlah",
      name: "txt",
      type: "text",
      visible: true,
      resource_label: (row) => (row.total != null ? row.total : "-"),
    },
    {
      label: "%",
      name: "txt",
      type: "text",
      visible: true,
      resource_label: (row) => (row.pct != null ? `${row.pct}%` : "-"),
    },
    {
      label: "Aksi Standar",
      name: "txt",
      type: "text",
      visible: true,
      resource_label: (row) => ACTION_BY_CLASSIFICATION[row.classification] || "-",
    },
  ],
};

export default [churnHealthDistributionSection];
